// i18n der Landing: Mechanismus aus @repo/i18n, Wörterbücher hier.
// Die fünf Sprachen sind dieselben wie im Back Office (de/es/en/ru/ka).
// Neue Sprache = de.ts kopieren, übersetzen, hier registrieren.

import { createI18n, languageName } from "@repo/i18n";
import { de } from "./de";
import { en } from "./en";
import { es } from "./es";
import { ru } from "./ru";
import { ka } from "./ka";
import type { Dict } from "./de";

export type { Dict };
export { languageName };

// Eager (kein Lazy-Loading): die Wörterbücher sind winzig, und eine
// Marketing-Seite soll ohne Nachlade-Flackern in der erkannten Sprache stehen.
const dictionaries: Record<string, Dict> = { de, es, en, ru, ka };

/** Wörterbuch einer bestimmten Sprache — für die Telefon-Demo, die ihre
 *  Karte unabhängig von der Seitensprache anzeigt. */
export function dictFor(code: string): Dict {
  return dictionaries[code] ?? en;
}

const { I18nProvider, useI18n, useT } = createI18n<Dict>({
  dictionaries,
  // Englisch als Fallback: die Landing richtet sich an unbekanntes Publikum —
  // wessen Browsersprache wir nicht anbieten, der versteht am ehesten Englisch.
  // (Agenda/Admin behalten es — dort sind die Nutzer bekannte Kunden.)
  fallback: "en",
  storageKey: "landing.lang",
});

export { I18nProvider, useI18n, useT };
